import axios from "axios";

const baseURL = '/api';

const internalFetch = axios.create({baseURL});
export default internalFetch;